import React, { useState } from 'react';
// import Modal from 'react-modal';
// import { MdClose } from 'react-icons/md';
import ProjectModal from '../helper/ProjectModal';
import {
  projectsData,
  filterOptions,
  buttonColor,
  myBG,
} from '../helper/constants';

export const Projects = ({ projects }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');

  const projectArray = projects || projectsData; // Use the prop array if provided, or fallback to projectsData

  const filterProjects = (filterOption) => {
    if (filterOption === 'All') {
      return projectArray;
    } else {
      const lowerCaseFilterOption = filterOption.toLowerCase();
      return projectArray.filter((project) =>
        project.category.some((category) =>
          category.toLowerCase().includes(lowerCaseFilterOption)
        )
      );
    }
  };

  const handleModalOpen = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  return (
    <div id='project' style={styles.heading}>
      {/* if - else */}
      {projects ? <h3>Project</h3> : <h2>Projects</h2>}

      {/* if no prop */}
      {!projects && (
        <div style={styles.filterBox}>
          <div style={styles.filters}>
            {filterOptions.map((option) => (
              <label
                key={option}
                style={{
                  ...styles.eachFilters,
                  ...(selectedFilter === option && styles.activeFilterButton),
                }}
              >
                <input
                  type='radio'
                  value={option}
                  checked={selectedFilter === option}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                />
                {option}
              </label>
            ))}
          </div>
        </div>
      )}

      <div style={styles.projectsContainer}>
        {/* {projectArray.map((project) => ( */}
        {filterProjects(selectedFilter)
          .sort((a, b) => a.id - b.id)
          .map((project) => (
            <div style={styles.projectSquare} key={project.id}>
              <h3 style={styles.projectTitle}>{project.title}</h3>
              <p style={styles.projectDescription}>{project.description}</p>
              <div style={styles.projectButtons}>
                {project.link && (
                  <a
                    href={project.link}
                    style={styles.button}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Code
                  </a>
                )}
                {project.demo && (
                  <button
                    style={styles.button}
                    onClick={() => handleModalOpen(project)}
                  >
                    Demo
                  </button>
                )}
                {!project.demo && (
                  <button
                    style={styles.buttonAnchor}
                    onClick={() => handleModalOpen(project)}
                  >
                    Details
                  </button>
                )}
              </div>
            </div>
          ))}
      </div>

      {/* Render the modal */}
      <ProjectModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        selectedProject={selectedProject}
      />
    </div>
  );
};

const styles = {
  heading: {
    // marginTop: '10px',
    marginLeft: '5px',
    marginBottom: '10px',
    marginRight: '5px',
    padding: '20px', // Add some padding to create space around the content
    // background: 'rgba(255, 255, 255, 0.2)', // Use an rgba color for the background with reduced opacity
    background: myBG,
    backdropFilter: 'blur(10px)', // Add a blur effect to create the glass panel effect
    borderRadius: '10px', // Add rounded corners for a better look
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', // Add a subtle shadow for depth
  },
  projectsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    justifyItems: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  projectSquare: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    background: 'white',
  },
  projectTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '10px',
    textAlign: 'center',
  },
  projectDescription: {
    marginBottom: '10px',
    textAlign: 'justify',
  },
  projectButtons: {
    display: 'flex',
    gap: '10px',
  },
  button: {
    padding: '8px 16px',
    // backgroundColor: '#007bff',
    backgroundColor: buttonColor,
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  buttonAnchor: {
    color: buttonColor,
    // border: 'none',
    padding: '0',
    background: 'none',
    // color: 'inherit',
    border: 'none',
    font: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    marginLeft: '10px',
  },
  filterBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    // border: '1px solid black',
    // '@media (max-width: 600px)': {
    //   flexDirection: 'column',
    //   alignItems: 'center',
    // },
  },
  filters: {
    display: 'flex', // wont help/make align center
    justifyContent: 'center',
    // display: 'inline-block', // will make background appear only surrounding the text and not entire row.
    textAlign: 'center',
    padding: '5px',
    paddingBottom: '5px',
    background: 'linear-gradient(45deg, #C13584, #8134AF, #405DE6, #5851DB)',
    borderRadius: '10px',
    whiteSpace: 'nowrap',
    // '@media (max-width: 600px)': {
    //   display: 'block',
    // },
    flexWrap: 'wrap',
    // border: '1px solid red',
  },
  eachFilters: {
    // display: 'flex',
    // // justifyContent: 'center',
    // // alignItems: 'center',
    // // flexDirection: 'row',
    // flexWrap: 'wrap',
    // border: '1px solid #ccc',
    marginRight: '8px',
    padding: '4px 8px',
    borderRadius: '4px',
    // backgroundColor: '#eee',
    cursor: 'pointer',
  },
  activeFilterButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '16px',
  },
};

export default Projects;
